export default "__VITE_ASSET__Cuvhf6Ao__"